import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cns - CNS do profissional
 */
export async function getCadastrosIndividuais(cod_ibge, nu_cns) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/hemoglobina-glicada/detalhado/' + cod_ibge + '/' + nu_cns
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da equipe
 * @param {int} micro_area - Micro área do profissional
 */
export async function getCadastrosIndividuaisPorMicroArea(
  cod_ibge,
  nu_ine,
  micro_area
) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/hemoglobina-glicada/detalhado/microarea/' +
        cod_ibge +
        '/' +
        nu_ine +
        '/' +
        micro_area
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem ACS de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisSemAcs(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/hemoglobina-glicada/detalhado/sem-acs/' + cod_ibge + '/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem equipe
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getCadastrosIndividuaisSemEquipe(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/hemoglobina-glicada/detalhado/sem-equipe/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/hemoglobina-glicada/detalhado/todos/equipe/' +
        cod_ibge +
        '/' +
        nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor de acordo com o valor
/**
 *
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 50) {
    return 'blue'
  } else {
    return 'red'
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 */
export function printTableRow(
  dias,
  dias_atendimento,
  dt_ultima_hemoglobina,
  dt_atendimento
) {
  if (
    dt_ultima_hemoglobina != null &&
    dias < 170 &&
    dt_atendimento != null &&
    dias_atendimento < 170
  ) {
    return 'green'
  } else {
    return 'red'
  }
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      item.dt_ultima_hemoglobina != null &&
      item.dias < 170 &&
      item.dt_atendimento != null &&
      item.dias_atendimento < 170
    ) {
      return false
    } else {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      item.dt_ultima_hemoglobina != null &&
      item.dias < 170 &&
      item.dt_atendimento != null &&
      item.dias_atendimento < 170
    ) {
      return true
    } else {
      return false
    }
  })
  return filtro
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional
) {
  let title_pdf = 'Atendimento diabetes'
  let titlePdfSave = utils.methods.titlePdf(
    'Atendimento diabetes',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Consulta e exame de Hemoglobina Glicada'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'AVALIADO',
    'EXAME',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    if (cadastros[i].dt_atendimento != null) {
      obj.dt_atendimento = utils.methods.formatDate(cadastros[i].dt_atendimento)
    } else {
      obj.dt_atendimento = 'Auto referido'
    }
    obj.dt_ultima_hemoglobina = utils.methods.formatDate(
      cadastros[i].dt_ultima_hemoglobina
    )

    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    obj.dias = cadastros[i].dias
    obj.dias_atendimento = cadastros[i].dias_atendimento
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let dt_atendimento = data.row.raw[4]
          let dt_ultima_hemoglobina = data.row.raw[5]
          let dias = parseInt(data.row.raw[7])
          let dias_atendimento = parseInt(data.row.raw[8])
          if (
            dt_ultima_hemoglobina != null &&
            dias < 170 &&
            dt_atendimento != null &&
            dias_atendimento < 170
          ) {
            doc.setTextColor(2, 99, 57) // verde
          } else {
            doc.setTextColor(194, 10, 16) // vermelho
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export async function carregarSerieHistoricaPorEquipe(cod_ibge, nu_ine, xaxis) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/equipe/' + cod_ibge + '/' + nu_ine + '/7'
    )
    let array_chart_equipe = []
    for (let i = 0; i < xaxis.length; i++) {
      var eixo_x_atual = xaxis[i]
      for (const item of response.data) {
        var resultado = 0
        if (item.mes_ano == eixo_x_atual) {
          resultado = item.resultado
          break
        } else {
          resultado = null
        }
      }
      array_chart_equipe.push(resultado)
    }
    return array_chart_equipe
  } catch (err) {
    console.log(err)
  }
}
export async function carregarSerieHistoricaPorAcs(
  cod_ibge,
  profissional,
  xaxis
) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/acs/' + cod_ibge + '/' + profissional + '/7'
    )

    let array_chart_acs = []
    if (response.data.length !== 0) {
      for (let i = 0; i < xaxis.length; i++) {
        var eixo_x_atual = xaxis[i]
        for (const item of response.data) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = item.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_acs.push(resultado)
      }
      return array_chart_acs
    } else {
      return null
    }
  } catch (err) {
    console.log(err)
  }
}

export function handleSituacao(data, situacao) {
  let filtrado = data.filter((item) => {
    if (situacao === 'Todos') {
      return item
    }
    if (situacao === 'Auto referido') {
      return item.dt_atendimento === null
    } else if (situacao === 'Últimos 30 dias') {
      return Number(item.dias_ult_atend) < 30 && item.dt_atendimento !== null
    } else if (situacao === 'Últimos 2 meses') {
      return Number(item.dias_ult_atend) < 60 && item.dt_atendimento !== null
    } else if (situacao === 'Últimos 3 meses') {
      return Number(item.dias_ult_atend) < 90 && item.dt_atendimento !== null
    } else if (situacao === 'Últimos 4 meses') {
      return Number(item.dias_ult_atend) < 120 && item.dt_atendimento !== null
    } else if (situacao === 'Entre 4 - 6 meses') {
      return (
        Number(item.dias_ult_atend) >= 120 &&
        Number(item.dias_ult_atend) <= 180 &&
        item.dt_atendimento !== null
      )
    } else if (situacao === 'Entre 6 - 12 meses') {
      return (
        Number(item.dias_ult_atend) > 180 &&
        Number(item.dias_ult_atend) <= 365 &&
        item.dt_atendimento !== null
      )
    } else if (situacao === '12 ou + meses') {
      return Number(item.dias_ult_atend) >= 365 && item.dt_atendimento !== null
    } else if (situacao === 'No numerador? Sim.') {
      return Number(item.dia_numerador) === 1
    } else if (situacao === 'No numerador? Não.') {
      return Number(item.dia_numerador) !== 1
    } else {
      return item
    }
  })
  return filtrado
}
